export const checkBoxStyle = {
  padding: 0,
  "& .MuiSvgIcon-root": {
    height: "16px",
    width: "16px",
  },
};
